module.exports = __webpack_public_path__ + "static/P2101534-6ca578dee4d60175ff6be9a5804dc9bc.jpg";